module.exports = __webpack_public_path__ + "static/media/Style17.f480e4cd.PNG";